import { render, staticRenderFns } from "./ExamCreation.vue?vue&type=template&id=30aa64c8"
import script from "./ExamCreation.vue?vue&type=script&lang=js"
export * from "./ExamCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports